(function () {
    /**
     * Works with formats:
     * ddd
     * ddd.dd
     * ddd,dd
     */
    App.filter('floatCurrencyFormatter', currencyFormatter);
    currencyFormatter.$inject = [];
    
    function currencyFormatter() {
        return function (value) {
            value = parseFloat(value).toFixed(2);
            value = value.replace(/\./g, ',');

            return value + ' zł';
        }
    }
})();
